import Phaser from "phaser";
import { EVENT, emit } from "./events";

export class BootScene extends Phaser.Scene {
  constructor() {
    super("boot");
  }

  preload(): void {
    const base = import.meta.env.BASE_URL;
    this.load.image("hero-art", `${base}art/butt-hero.png`);
    this.load.image("pellet-art", `${base}art/poop-pellet.png`);
    this.load.image("toilet-regular", `${base}art/toilet-regular-v2.png`);
    this.load.image("toilet-speedy", `${base}art/toilet-speedy-v2.png`);
    this.load.image("toilet-sturdy", `${base}art/toilet-sturdy-v2.png`);
    this.load.image("toilet-boss", `${base}art/toilet-boss-v2.png`);
    this.load.image(
      "toilet-regular-dark",
      `${base}art/toilet-regular-dark-v3.png`,
    );
    this.load.image(
      "toilet-speedy-dark",
      `${base}art/toilet-speedy-dark-v3.png`,
    );
    this.load.image(
      "toilet-sturdy-dark",
      `${base}art/toilet-sturdy-dark-v3.png`,
    );
    this.load.image("toilet-boss-dark", `${base}art/toilet-boss-dark-v3.png`);
  }

  create(): void {
    this.makeBonusProjectiles();
    this.makePowerUps();
    this.makeParticles();
    emit(EVENT.gameReady, undefined);
  }

  private makeBonusProjectiles(): void {
    const bubble = this.make.graphics({ x: 0, y: 0 });
    bubble
      .fillStyle(0x71e4d0, 0.38)
      .fillCircle(24, 24, 18)
      .lineStyle(4, 0xd9c7ff, 0.95)
      .strokeCircle(24, 24, 18)
      .fillStyle(0xffffff, 0.9)
      .fillCircle(18, 17, 5)
      .fillStyle(0xffcf5c, 0.85)
      .fillCircle(31, 29, 3);
    bubble.generateTexture("shot-bubble", 48, 48).destroy();

    const plunger = this.make.graphics({ x: 0, y: 0 });
    plunger
      .fillStyle(0xff6fa9)
      .fillRoundedRect(4, 5, 32, 18, 9)
      .lineStyle(3, 0x301a4b)
      .strokeRoundedRect(4, 5, 32, 18, 9)
      .fillStyle(0xffcf5c)
      .fillRoundedRect(16, 18, 8, 34, 4)
      .lineStyle(3, 0x301a4b)
      .strokeRoundedRect(16, 18, 8, 34, 4)
      .fillStyle(0xfff3d6)
      .fillCircle(20, 50, 4);
    plunger.generateTexture("shot-plunger", 40, 56).destroy();
  }

  private makePowerUps(): void {
    const shield = this.make.graphics({ x: 0, y: 0 });
    shield.fillStyle(0xffffff).fillCircle(28, 28, 25);
    shield.lineStyle(4, 0x71e4d0).strokeCircle(28, 28, 24);
    shield.fillStyle(0x71e4d0).fillRect(18, 14, 20, 28);
    shield.fillStyle(0xffffff).fillCircle(28, 23, 7).fillRect(21, 23, 14, 13);
    shield.generateTexture("power-shield", 56, 56).destroy();

    const triple = this.make.graphics({ x: 0, y: 0 });
    triple.fillStyle(0xffcf5c).fillCircle(28, 28, 25);
    triple.lineStyle(4, 0xffffff).strokeCircle(28, 28, 24);
    triple
      .fillStyle(0x7d4c3a)
      .fillCircle(17, 29, 8)
      .fillCircle(28, 18, 8)
      .fillCircle(39, 29, 8);
    triple.generateTexture("power-triple", 56, 56).destroy();
  }

  private makeParticles(): void {
    const g = this.make.graphics({ x: 0, y: 0 });
    g.fillStyle(0xffffff).fillCircle(5, 5, 5);
    g.generateTexture("spark", 10, 10).destroy();
  }
}
